import urlConfig from "@adapters/infrastructures/urlConfig/homeUrl";
export var NEWS = "news";
var NewsRequestMapper = /** @class */ (function () {
    function NewsRequestMapper() {
    }
    NewsRequestMapper.prototype.formatRequest = function (reqType, subscribe) {
        var subReq = {
            request: {
                streaming_type: reqType,
                data: {},
                formFactor: "W",
                response_format: "json",
                request_type: subscribe ? "subscribe" : "unsubscribe",
                appID: urlConfig.appid,
            },
            echo: {},
        };
        return JSON.stringify(subReq);
    };
    return NewsRequestMapper;
}());
export default NewsRequestMapper;
